import React, { useContext, useEffect, useState } from "react";
import "../styles/StartMenu.css";
import { Link } from "react-router-dom";

import { UiTextsContext } from "../../../contexts/Contexts";
import {
  eventsPath,
  culturePath,
  communityPath,
  foodPath,
  calmPath,
  coWorkingPath,
  housingPath,
} from "../../../routes/routes";
import NewSideBar from "../NewSideBar";

const StartMenu = () => {
  const [cards, setCards] = useState([]);
  const { uiTexts } = useContext(UiTextsContext);

  useEffect(() => {
    setCards([
      {
        icon: "/img/icons/Events.svg",
        label: uiTexts?.LB0167 || "Events",
        route: eventsPath,
      },
      {
        icon: "/img/icons/cultura.svg",
        label: uiTexts?.LB0056 || "Culture",
        route: culturePath,
      },
      {
        icon: "/img/icons/comunidad.svg",
        label: uiTexts?.LB0057 || "Community",
        route: communityPath,
      },
      {
        icon: "/img/icons/comida.svg",
        label: uiTexts?.LB0058 || "Food",
        route: foodPath,
      },
      {
        icon: "/img/icons/calma.svg",
        label: uiTexts?.LB0059 || "Calm",
        route: calmPath,
      },
  
      {
        icon: "/img/icons/co-living.svg",
        label: uiTexts?.LB0055 || "Housing",
        route: housingPath,
      },
    ]);
  }, [uiTexts]);

  return (
    <div className="start-menu">
      <div className="start-menu-wrapper">
        <div className="start-menu-cards">
          {cards.map(({ label, icon, route }) => (
            <div className="start-card-wrapper">
              <Link to={route} className="start-card" key={label}>
                <div className="start-card-content">
                  <img src={icon} alt={label} className="start-icon" />
                  <span className="start-label">{label}</span>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
      <NewSideBar />
    </div>
  );
};

export default StartMenu;
